import { Media } from '../models/Media';
import { uderlyConfig } from "..";

import Settings from "../data/settings";
import { errorLog } from './Utils';
import { MagicAccessRequest } from '../models/MagicAccessRequest';
import { NewsletterRequest } from '../models/Newsletter';
import ContactFormRequest from '../models/Contact';

export const login = async (username: string, password: string, grantType = "password", provider = "", accessToken = "", name = "", surname = "") => {
  const data = {
    "grant_type": grantType,
    "client_id": Settings.auth && Settings.auth.clientId,
    "client_secret": Settings.auth && Settings.auth.clientSecret,
    "username": username,
    "password": password,
    "provider": provider,
    "access_token": accessToken,
    "name": name,
    "surname": surname,
    "email": username,
    "intent": 1 // SignIn
  };

  const response = await uderlyConfig.Axios?.post(Settings.apiUrl + '/auth/access', data).catch(function (error) {
    return errorLog(error);
  });

  return response;
}

export const magicAccess = async (request: MagicAccessRequest) => {
  if (!request.path)
    request.path = window.location.pathname;
  if (!request.intent)
    request.intent = 3; // MagicLink

  const response = await uderlyConfig.Axios?.post(Settings.apiUrl + '/auth/access', request).catch(function (error) {
    return errorLog(error);
  });

  return response;
}

export const checkExistance = async (email: string) => {
  return await uderlyConfig.Axios?.post(Settings.apiUrl + "/auth/checkexistance", { email })
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const verify = async () => {
  return await uderlyConfig.Axios?.post(Settings.apiUrl + "/auth/verify")
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const requestResetPassword = async (email: string) => {
  return await uderlyConfig.Axios?.post(Settings.apiUrl + "/auth/password/requestreset", { email })
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const resetPassword = async (email: string, password: string, token: string | null) => {
  return await uderlyConfig.Axios?.post(Settings.apiUrl + "/auth/password/reset", { email, token, password })
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const getMyself = async () => {
  return await uderlyConfig.Axios?.get(Settings.apiUrl + "/users/myself")
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const getSettings = async () => {
  return await uderlyConfig.Axios?.get(Settings.apiUrl + "/settings")
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const updateMyself = async (values: any) => {
  return await uderlyConfig.Axios?.put(Settings.apiUrl + "/users/myself", values)
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const getLanguages = async () => {
  return await uderlyConfig.Axios?.get(Settings.apiUrl + "/languages")
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const addMedia = async (path: string, modelId: number, mediaList: Media[], collection = "asset") => {
  const url = Settings.apiUrl + path + "/" + modelId + "/media/add";

  const data = {
    media: mediaList,
    collection: collection
  };

  return await uderlyConfig.Axios?.post(url, data)
    .catch((error) => {
      console.log(error);
      errorLog(error);
      return error.response;
    });
}

export const removeMedia = async (path: string, mediaId: number) => {
  const url = Settings.apiUrl + path + "/media/remove/" + mediaId;

  return await uderlyConfig.Axios?.delete(url)
    .catch((error) => {
      console.log(error);
      errorLog(error);
      return error.response;
    });
}

export const downloadMedia = async (basePath: string, media: Media) => {
  const url = basePath + "/media/" + media.id + "/download";

  if (uderlyConfig.Axios)
    return uderlyConfig.Axios({
      url: url,
      method: 'GET',
      responseType: 'blob',
    }).then((response) => {
      // create file link in browser's memory
      const href = URL.createObjectURL(response.data);

      // create "a" HTML element with href to file & click
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', media.file_name);
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    });

  return null;
}

export const requestAccountDeletion = async () => {
  return await uderlyConfig.Axios?.post(Settings.apiUrl + "/users/myself/delete")
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const submitContact = async (contact: ContactFormRequest | NewsletterRequest) => {
  return await uderlyConfig.Axios?.post(Settings.apiUrl + "/contacts", contact)
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const getPermissions = async () => {
  return await uderlyConfig.Axios?.get(Settings.apiUrl + "/roles/permissions")
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const getCountries = async () => {
  return await uderlyConfig.Axios?.get(Settings.apiUrl + "/countries")
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}

export const requestNewsletterUnsubscribe = async (email: string, storeId: undefined | number | null, value: boolean) => {
  return await uderlyConfig.Axios?.put(Settings.apiUrl + "/contacts/unsubscribe",
    {
      email: email,
      store_id: storeId,
      value: value
    })
    .catch((error) => {
      console.log('error ' + error);
      return errorLog(error);
    });
}